import { render, staticRenderFns } from "./New_list.vue?vue&type=template&id=1ff3a64f&scoped=true&"
import script from "./New_list.vue?vue&type=script&lang=js&"
export * from "./New_list.vue?vue&type=script&lang=js&"
import style0 from "./New_list.vue?vue&type=style&index=0&id=1ff3a64f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff3a64f",
  null
  
)

export default component.exports